export const TAG_LIST = {
    // MESSAGING_TAG: "Messaging tags",
    CLASSIFICATION_TAG: "Classification tags",
    // TICKET_TYPES: "Ticket types",
};
